import React, { useRef, useState } from "react";
import {
  Card,
  CardBody,
  Col,
  Container,
  NavItem,
  NavLink,
  Row,
  Table,
  Button,
} from "reactstrap";
//Import Breadcrumb
import classnames from "classnames";
import _, { update } from "lodash";
import { useMutation, useQuery, useLazyQuery } from "react-apollo";
import SweetAlert from "react-bootstrap-sweetalert";
import { withTranslation } from "react-i18next";
import InfiniteScroll from "react-infinite-scroll-component";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { DELETE_TRANSACTION } from "../../graphql/mutation";
import { GET_ENUM, GET_TRANSACTIONS_TOTAL_COUNT } from "../../graphql/query";
import { CSVLink } from "react-csv";
import { GET_TRANSACTIONS } from "../../graphql/query/GET_TRANSACTIONS";
import ToastHelper from "../../helpers/ToastHelper";
import { toggleRightSidebar } from "../../store/actions";
import TransactionItem from "./transaction-item";
import DatePicker from "react-datepicker";
import moment from "moment";

function TransactionDepositGateway(props) {
  const first = 50;
  const { t } = props;
  const { tab } = props.match.params;
  const csvLink = React.useRef(null);

  const { data: paymentGatewayProviderCodeData } = useQuery(GET_ENUM, {
    variables: {
      name: "PaymentGatewayProviderCode",
    },
  });

  const [search, setSearch] = React.useState(
    props.location.state && props.location.state.serialNo
      ? props.location.state.serialNo
      : ""
  );
  const [searchValue, setSearchValue] = React.useState(
    props.location.state && props.location.state.serialNo
      ? props.location.state.serialNo
      : ""
  );

  const [paymentGatewayProviderCode, setPaymentGatewayProviderCode] =
    React.useState([]);

  const [isSearch, setIsSearch] = React.useState(false);
  const [afterCursor, setAfterCursor] = React.useState(null);
  const [pageInfo, setPageInfo] = React.useState(false);
  const [isFetchMore, setIsFetchMore] = React.useState(false);
  const [activeTab, setActiveTab] = React.useState("Approved");
  const [filter, setFilter] = React.useState({
    transactionType: { eq: "Deposit" },
  });
  const [orderBy, setOrderBy] = React.useState("createdAt");
  const [orderDirection, setOrderDirection] = React.useState("DESC");
  const history = useHistory();
  const [confirmDelete, setConfirmDelete] = React.useState(false);
  const [transaction, setTransaction] = React.useState(false);
  const [showReject, setShowReject] = React.useState(false);

  const [updatedAtDateRange, setUpdatedAtDateRange] = useState([null, null]);
  const [paidAtDateRange, setPaidAtDateRange] = useState([null, null]);

  const [csvData, setCSVData] = React.useState([]);
  const [readyDownload, setReadyDownload] = React.useState(false);

  const Filter = (filter) => {
    if (_.isEmpty(search)) {
      if (_.isEmpty(props.filter)) {
        if (!_.isEmpty(paymentGatewayProviderCode)) {
          return {
            and: [
              {
                ...filter,
                transactionStatus:
                  activeTab === null
                    ? { in: ["Approved", "Rejected", "Pending", "Viewed"] }
                    : { eq: activeTab },
                paymentGatewayProviderCode: { in: paymentGatewayProviderCode },
              },
            ],
          };
        } else {
          return {
            and: [
              {
                ...filter,
                transactionStatus:
                  activeTab === null
                    ? { in: ["Approved", "Rejected", "Pending", "Viewed"] }
                    : { eq: activeTab },
                or: [
                  !_.isEmpty(paymentGatewayProviderCode)
                    ? {
                        paymentGatewayProviderCode: {
                          in: paymentGatewayProviderCode,
                        },
                      }
                    : {
                        isActive: { is: true },
                      },
                ],
              },
            ],
          };
        }
      } else {
        return {
          ...filter,
          transactionStatus:
            activeTab === null
              ? { in: ["Approved", "Rejected", "Pending", "Viewed"] }
              : { eq: activeTab },
          and: [
            props.filter,
            {
              or: [
                !_.isEmpty(paymentGatewayProviderCode)
                  ? {
                      paymentGatewayProviderCode: {
                        in: paymentGatewayProviderCode,
                      },
                    }
                  : {
                      isActive: { is: true },
                    },
              ],
            },
          ],
        };
      }
    } else {
      if (_.isEmpty(props.filter)) {
        return {
          and: [
            {
              ...filter,
              transactionStatus:
                activeTab === null
                  ? { in: ["Approved", "Rejected", "Pending", "Viewed"] }
                  : { eq: activeTab },
            },
            {
              or: [
                !_.isEmpty(paymentGatewayProviderCode)
                  ? {
                      paymentGatewayProviderCode: {
                        in: paymentGatewayProviderCode,
                      },
                    }
                  : {
                      isActive: { is: true },
                    },
              ],
            },
            {
              or: [
                { serialNo: { iLike: `%${search}%` } },
                {
                  or: [{ player: { username: { iLike: `%${search}%` } } }],
                },
              ],
            },
          ],
        };
      } else {
        return {
          ...filter,
          transactionStatus:
            activeTab === null
              ? { in: ["Approved", "Rejected", "Pending", "Viewed"] }
              : { eq: activeTab },
          and: [
            props.filter,
            {
              or: [
                !_.isEmpty(paymentGatewayProviderCode)
                  ? {
                      paymentGatewayProviderCode: {
                        in: paymentGatewayProviderCode,
                      },
                    }
                  : {
                      isActive: { is: true },
                    },
              ],
            },
            {
              or: [
                { serialNo: { iLike: `%${search}%` } },
                {
                  or: [{ player: { username: { iLike: `%${search}%` } } }],
                },
              ],
            },
          ],
        };
      }
    }
  };

  const CountFilter = () => {
    if (_.isEmpty(search)) {
      if (_.isEmpty(props.filter)) {
        return {};
      } else {
        return {
          and: [props.filter],
        };
      }
    } else {
      if (_.isEmpty(props.filter)) {
        return {
          or: [
            { serialNo: { iLike: `%${search}%` } },
            { player: { username: { iLike: `%${search}%` } } },
          ],
        };
      } else {
        return {
          and: [
            props.filter,
            {
              or: [
                { serialNo: { iLike: `%${search}%` } },
                { player: { username: { iLike: `%${search}%` } } },
              ],
            },
          ],
        };
      }
    }
  };

  const [transactionFilter, setTransactionFilter] = React.useState({
    ...Filter(filter),
  });
  const [pendingFilter, setPendingFilter] = React.useState({
    ...CountFilter(),
    transactionType: { eq: "Deposit" },
    transactionStatus: { eq: "Pending" },
    or: [
      !_.isEmpty(paymentGatewayProviderCode)
        ? { paymentGatewayProviderCode: { in: paymentGatewayProviderCode } }
        : {
            isActive: { is: true },
          },
    ],
  });
  const [viewedFilter, setViewedFilter] = React.useState({
    ...CountFilter(),
    transactionType: { eq: "Deposit" },
    transactionStatus: { eq: "Viewed" },
    or: [
      !_.isEmpty(paymentGatewayProviderCode)
        ? { paymentGatewayProviderCode: { in: paymentGatewayProviderCode } }
        : {
            isActive: { is: true },
          },
    ],
  });

  const [deleteTransaction] = useMutation(DELETE_TRANSACTION, {
    update: (cache) => {
      const existingTransactions = cache.readQuery({
        query: GET_TRANSACTIONS,
        variables: {
          filter: Filter(filter),
          sorting: [
            {
              field: orderBy,
              direction: orderDirection,
            },
          ],
        },
      });
      cache.writeQuery({
        query: GET_TRANSACTIONS,
        variables: {
          filter: Filter(filter),
          sorting: [
            {
              field: orderBy,
              direction: orderDirection,
            },
          ],
        },
        data: {
          transactions: {
            pageInfo: existingTransactions.transactions.pageInfo,
            edges: existingTransactions.transactions.edges.filter(
              (t) => t.node.id !== transaction.node.id
            ),
          },
        },
      });
    },
  });

  const {
    data: transactionData,
    fetchMore,
    loading,
    refetch,
  } = useQuery(GET_TRANSACTIONS, {
    variables: {
      paging: {
        first: first,
      },
      filter: {
        ...transactionFilter,
        updatedAt:
          !_.isNull(updatedAtDateRange[0]) && !_.isNull(updatedAtDateRange[1])
            ? {
                between: {
                  lower: `${moment(updatedAtDateRange[0]).format(
                    "YYYY-MM-DD"
                  )} 00:00:00:00`,
                  upper: `${moment(updatedAtDateRange[1]).format(
                    "YYYY-MM-DD"
                  )} 23:59:59:59`,
                },
              }
            : { lte: `${moment().format("YYYY-MM-DD")} 23:59:59:59` },
        // paidAt:
        //   !_.isNull(paidAtDateRange[0]) && !_.isNull(paidAtDateRange[1])
        //     ? {
        //         between: {
        //           lower: `${moment(paidAtDateRange[0]).format(
        //             "YYYY-MM-DD"
        //           )} 00:00:00:00`,
        //           upper: `${moment(paidAtDateRange[1]).format(
        //             "YYYY-MM-DD"
        //           )} 23:59:59:59`,
        //         },
        //       }
        //     : { lte: `${moment().format("YYYY-MM-DD")} 23:59:59:59` },
      },
      sorting: [
        {
          field: orderBy,
          direction: orderDirection,
        },
      ],
    },
    fetchPolicy: "network-only",
  });

  const { data: depositCount, refetch: refetchDeposit } = useQuery(
    GET_TRANSACTIONS_TOTAL_COUNT,
    {
      variables: {
        filter: {
          ...pendingFilter,
        },
      },
      fetchPolicy: "network-only",
    }
  );

  const { data: viewedCount, refetch: refetchView } = useQuery(
    GET_TRANSACTIONS_TOTAL_COUNT,
    {
      variables: {
        filter: {
          ...viewedFilter,
        },
      },
      fetchPolicy: "network-only",
    }
  );

  const [getCSVData, { data: csvTempData }] = useLazyQuery(GET_TRANSACTIONS, {
    variables: {
      paging: {
        first: first,
      },
      filter: {
        ...transactionFilter,
        paymentGatewayProviderCode: {
          in: !_.isEmpty(paymentGatewayProviderCode)
            ? paymentGatewayProviderCode
            : paymentGatewayProviderCodeData?.__type.enumValues.map(
                ({ name }) => name
              ),
        },
        updatedAt:
          !_.isNull(updatedAtDateRange[0]) && !_.isNull(updatedAtDateRange[1])
            ? {
                between: {
                  lower: `${moment(updatedAtDateRange[0]).format(
                    "YYYY-MM-DD"
                  )} 00:00:00:00`,
                  upper: `${moment(updatedAtDateRange[1]).format(
                    "YYYY-MM-DD"
                  )} 23:59:59:59`,
                },
              }
            : { lte: `${moment().format("YYYY-MM-DD")} 23:59:59:59` },
      },
      sorting: [
        {
          field: orderBy,
          direction: orderDirection,
        },
      ],
    },
    fetchPolicy: "network-only",
  });

  React.useEffect(() => {
    if (csvData.length > 0) {
      if (csvTempData.transactions.pageInfo.hasNextPage) {
        getCSVData({
          variables: {
            paging: {
              first: first,
              after: csvTempData.transactions.pageInfo.endCursor,
            },
            filter: {
              ...transactionFilter,
              paymentGatewayProviderCode: {
                in: !_.isEmpty(paymentGatewayProviderCode)
                  ? paymentGatewayProviderCode
                  : paymentGatewayProviderCodeData?.__type.enumValues.map(
                      ({ name }) => name
                    ),
              },
              updatedAt:
                !_.isNull(updatedAtDateRange[0]) &&
                !_.isNull(updatedAtDateRange[1])
                  ? {
                      between: {
                        lower: `${moment(updatedAtDateRange[0]).format(
                          "YYYY-MM-DD"
                        )} 00:00:00:00`,
                        upper: `${moment(updatedAtDateRange[1]).format(
                          "YYYY-MM-DD"
                        )} 23:59:59:59`,
                      },
                    }
                  : { lte: `${moment().format("YYYY-MM-DD")} 23:59:59:59` },
            },
            sorting: [
              {
                field: orderBy,
                direction: orderDirection,
              },
            ],
          },
        });
      } else if (csvData.length > 0 && csvLink && readyDownload) {
        csvLink.current.link.click();
        setReadyDownload(false);
        setCSVData([]);
      }
    }
  }, [csvData]);

  React.useEffect(() => {
    if (csvTempData && readyDownload) {
      setCSVData((prevData) => [
        ...prevData,
        ...csvTempData.transactions.edges.map((item) => item.node),
      ]);
    }
  }, [csvTempData]);

  React.useEffect(() => {
    if (!_.isEmpty(props.filter)) {
      setTransactionFilter({ ...Filter(filter) });
      setPendingFilter({
        ...CountFilter(),
        transactionType: { eq: "Deposit" },
        transactionStatus: { eq: "Pending" },
      });
      setViewedFilter({
        ...CountFilter(),
        transactionType: { eq: "Deposit" },
        transactionStatus: { eq: "Viewed" },
      });
    } else {
      if (activeTab === null) {
        setTransactionFilter({
          ...Filter({ ...filter }),
        });
      } else {
        setTransactionFilter({
          ...Filter({ ...filter }),
        });
      }
    }
  }, [
    search,
    props.filter,
    paymentGatewayProviderCode,
    paymentGatewayProviderCodeData,
    updatedAtDateRange,
    activeTab,
  ]);

  const DeleteTransaction = async () => {
    setConfirmDelete(false);
    await deleteTransaction({
      variables: {
        id: transaction.node.id,
      },
    })
      .catch((e) => {
        ToastHelper.toggleToast({
          toastType: "error",
          message: e,
          title: "",
          onClick: function () {},
        });
      })
      .then((val) => {
        if (val) {
          ToastHelper.toggleToast({
            message: "Transaction Deleted",
            title: "",
            onClick: function () {},
          });
          refetchDeposit();
          refetchView();
        }
      });
  };

  React.useEffect(() => {
    if (transactionData) {
      setAfterCursor(transactionData.transactions.pageInfo.endCursor);
      setPageInfo(transactionData.transactions.pageInfo);
    }
  }, [transactionData]);

  React.useEffect(() => {
    if (tab === "pending") {
      setActiveTab("Pending");
      UpdateFilter("Pending");
    } else if (tab === "all") {
      setActiveTab(null);
      UpdateFilter(null);
    }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  React.useEffect(() => {
    if (isFetchMore) {
      fetchMore({
        variables: {
          paging: {
            first: first,
            after: afterCursor,
          },
          filter: {
            ...Filter(filter),
            updatedAt:
              !_.isNull(updatedAtDateRange[0]) &&
              !_.isNull(updatedAtDateRange[1])
                ? {
                    between: {
                      lower: `${moment(updatedAtDateRange[0]).format(
                        "YYYY-MM-DD"
                      )} 00:00:00:00`,
                      upper: `${moment(updatedAtDateRange[1]).format(
                        "YYYY-MM-DD"
                      )} 23:59:59:59`,
                    },
                  }
                : { lte: `${moment().format("YYYY-MM-DD")} 23:59:59:59` },
            // paidAt:
            //   !_.isNull(paidAtDateRange[0]) && !_.isNull(paidAtDateRange[1])
            //     ? {
            //         between: {
            //           lower: `${moment(paidAtDateRange[0]).format(
            //             "YYYY-MM-DD"
            //           )} 00:00:00:00`,
            //           upper: `${moment(paidAtDateRange[1]).format(
            //             "YYYY-MM-DD"
            //           )} 23:59:59:59`,
            //         },
            //       }
            //     : { lte: `${moment().format("YYYY-MM-DD")} 23:59:59:59` },
          },
          sorting: [
            {
              field: orderBy,
              direction: orderDirection,
            },
          ],
        },
        updateQuery: (previousResult, { fetchMoreResult }) => {
          const newEdges = fetchMoreResult.transactions.edges;
          const pageInfo = fetchMoreResult.transactions.pageInfo;
          setIsFetchMore(false);
          setAfterCursor(pageInfo.endCursor);

          return newEdges.length
            ? {
                transactions: {
                  __typename: previousResult.transactions.__typename,
                  edges: _.uniqBy(
                    [...previousResult.transactions.edges, ...newEdges],
                    "node.id"
                  ),
                  pageInfo,
                },
              }
            : previousResult;
        },
      });
    }
  }, [isFetchMore]); // eslint-disable-line react-hooks/exhaustive-deps

  const UpdateFilter = (type) => {
    if (type !== null) {
      setFilter(
        { transactionType: { eq: "Deposit" } },
        { transactionStatus: { eq: type } }
      );

      setTransactionFilter({
        ...Filter(
          { transactionType: { eq: "Deposit" } },
          { transactionStatus: { eq: type } }
        ),
      });
    } else {
      setFilter({ transactionType: { eq: "Deposit" } });

      setTransactionFilter({
        ...Filter({ transactionType: { eq: "Deposit" } }),
      });
    }
  };

  const OrderBy = (type) => {
    if (orderBy === type) {
      if (orderDirection === "ASC") {
        setOrderDirection("DESC");
      } else {
        setOrderDirection("ASC");
      }
    } else {
      setOrderDirection("ASC");
      setOrderBy(type);
    }
  };

  const Header = (props) => {
    const { type, className, name } = props;

    return (
      <th className={`pointer ${className}`} onClick={() => OrderBy(type)}>
        <div
          className={classnames({
            "align-center": orderBy === type,
          })}
        >
          <div>{t(name)}</div>
          {orderBy === type && (
            <>
              {orderDirection === "ASC" && <i className="bx bx-sort-up"></i>}
              {orderDirection === "DESC" && <i className="bx bx-sort-down"></i>}
            </>
          )}
        </div>
      </th>
    );
  };

  const debouncedSave = useRef(
    _.debounce((nextValue) => setSearch(nextValue), 300)
  ).current;

  const DownloadToCSV = () => {
    getCSVData();
    setReadyDownload(true);
  };

  const CSVDownload = () => {
    return (
      <>
        <Button color="primary" onClick={DownloadToCSV} style={{ width: 165 }}>
          {t("  Download (CSV)")}
          {readyDownload && <i className="bx bx-hourglass bx-spin ml-3"></i>}
        </Button>
        <CSVLink
          ref={csvLink}
          filename={"transaction-deposit-gateway.csv"}
          className="hidden"
          data={
            csvData
              ? _.map(csvData).map((item) => {
                  return {
                    ...item,
                    ...{
                      createdAt: moment(item.createdAt).format(
                        "YYYY-MM-DD HH:mm:ss"
                      ),
                      updatedAt: moment(item.updatedAt).format(
                        "YYYY-MM-DD HH:mm:ss"
                      ),
                    },
                  };
                })
              : []
          }
          headers={[
            { label: "Serial No", key: "serialNo" },
            { label: "Created At", key: "createdAt" },
            { label: "Username", key: "player.username" },
            { label: "Name", key: "player.name" },
            { label: "Amount", key: "amount" },
            { label: "Bonus", key: "bonusAmount" },
            { label: "Total Amount", key: "totalAmount" },
            { label: "Movement", key: "movement" },
            {
              label: "Gateway Provide Code",
              key: "paymentGatewayProviderCode",
            },
            {
              label: "Updated At",
              key: "updatedAt",
            },
          ]}
        ></CSVLink>
      </>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content transactions-page max-height">
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="Transactions" breadcrumbItem="Deposit (All)" />
          <div className="search-bar-container">
            <div className="button-add-bank-container">
              <div className="app-search d-none d-lg-block">
                <div className="position-relative">
                  <input
                    value={searchValue}
                    type="text"
                    className="form-control"
                    placeholder="Search..."
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                      debouncedSave(e.target.value);
                    }}
                  />
                  <span className="bx bx-search-alt"></span>
                </div>
              </div>
              <div className="d-flex">
                <div className="dropdown d-inline-block d-lg-none ml-2">
                  <button
                    type="button"
                    className="btn header-item noti-icon waves-effect"
                    id="page-header-search-dropdown"
                    onClick={() => {
                      setIsSearch(!isSearch);
                    }}
                  >
                    <i className="mdi mdi-magnify"></i>
                  </button>
                  <div
                    className={
                      isSearch
                        ? "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 show"
                        : "dropdown-menu dropdown-menu-lg dropdown-menu-right p-0"
                    }
                    aria-labelledby="page-header-search-dropdown"
                  >
                    <form className="p-3">
                      <div className="form-group m-0">
                        <div className="input-group">
                          <input
                            value={searchValue}
                            type="text"
                            className="form-control"
                            placeholder="Search..."
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                              debouncedSave(e.target.value);
                            }}
                          />
                          <div className="input-group-append">
                            <button className="btn btn-primary" type="submit">
                              <i className="mdi mdi-magnify"></i>
                            </button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Row>
            <div className="button-container ml-3">
              <div className="mb-2 mr-2 font-weight-medium">
                {"Payment Gateway Provider Code: "}
              </div>
              {paymentGatewayProviderCodeData?.__type.enumValues.map(
                ({ name }, index) => (
                  <div
                    className={classnames({
                      btn: true,
                      "mr-2": true,
                      "mb-2": true,
                      "font-size-10": true,
                      "btn-outline-primary": true,
                      "btn-primary": paymentGatewayProviderCode?.includes(name),
                      "cursor-pointer": true,
                      "text-white": paymentGatewayProviderCode?.includes(name),
                    })}
                    key={index}
                    onClick={() => {
                      if (paymentGatewayProviderCode?.includes(name)) {
                        setPaymentGatewayProviderCode(
                          paymentGatewayProviderCode.filter(
                            (code) => code !== name
                          )
                        );
                      } else {
                        setPaymentGatewayProviderCode([
                          ...paymentGatewayProviderCode,
                          name,
                        ]);
                      }
                    }}
                  >
                    {name}
                  </div>
                )
              )}
            </div>
          </Row>
          <div
            className="ml-2 mb-2"
            style={{ display: "flex", justifyContent: "flex-end" }}
          >
            <CSVDownload />
          </div>
          <Card>
            <CardBody>
              <Row>
                <Col sm="12">
                  <div className="overflow-auto">
                    <ul className="nav nav-tabs nav-tabs-custom mb-2">
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === "Approved",
                          })}
                          onClick={() => {
                            setActiveTab("Approved");
                            UpdateFilter("Approved");
                            setShowReject(false);
                          }}
                        >
                          Approved
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === "Rejected",
                          })}
                          onClick={() => {
                            setActiveTab("Rejected");
                            UpdateFilter("Rejected");
                            setShowReject(true);
                          }}
                        >
                          Rejected
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === "Pending",
                          })}
                          onClick={() => {
                            setActiveTab("Pending");
                            UpdateFilter("Pending");
                            setShowReject(false);
                          }}
                        >
                          Pending
                          {depositCount && (
                            <span>{` (${depositCount.transactions.totalCount})`}</span>
                          )}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({
                            active: activeTab === "Viewed",
                          })}
                          onClick={() => {
                            setActiveTab("Viewed");
                            UpdateFilter("Viewed");
                            setShowReject(false);
                          }}
                        >
                          Viewed
                          {viewedCount && (
                            <span>{` (${viewedCount.transactions.totalCount})`}</span>
                          )}
                        </NavLink>
                      </NavItem>
                      <NavItem>
                        <NavLink
                          className={classnames({ active: activeTab === null })}
                          onClick={() => {
                            setActiveTab(null);
                            UpdateFilter(null);
                            setShowReject(true);
                          }}
                        >
                          All
                        </NavLink>
                      </NavItem>
                    </ul>
                    {transactionData && (
                      <InfiniteScroll
                        dataLength={transactionData.transactions.edges.length} //This is important field to render the next data
                        next={() => setIsFetchMore(true)}
                        hasMore={pageInfo.hasNextPage}
                        loader={
                          <div className="text-center my-3">
                            <Link to="#" className="text-success">
                              <i className="bx bx-hourglass bx-spin mr-2"></i>{" "}
                              Load more{" "}
                            </Link>
                          </div>
                        }
                        endMessage={
                          <div className="text-center my-3">
                            <div>Yay! You have seen it all</div>
                          </div>
                        }
                      >
                        <Table className="table mb-0">
                          <thead>
                            <tr className="font-size-12">
                              <Header
                                name="Serial No"
                                className=""
                                type="serialNo"
                              />
                              <Header
                                name="Created At"
                                className=""
                                type="createdAt"
                              />
                              <th>Username</th>
                              <th>Name</th>
                              <th>Image/Payment Details</th>
                              <Header
                                name="Amount"
                                className=""
                                type="amount"
                              />
                              <Header name="Bonus" className="" type="bonus" />
                              <Header
                                name="Total Amount"
                                className=""
                                type="totalAmount"
                              />
                              <th>Movement</th>
                              {showReject && (
                                <>
                                  <th>Reject Reason</th>
                                  <th>Reject Remark</th>
                                </>
                              )}
                              <th>
                                <div className="d-flex">
                                  <div className="pr-2">Updated At</div>
                                  <DatePicker
                                    startDate={updatedAtDateRange[0]}
                                    endDate={updatedAtDateRange[1]}
                                    selectsRange
                                    customInput={
                                      <i className="bx bx-filter-alt font-size-15 cursor-pointer"></i>
                                    }
                                    onChange={setUpdatedAtDateRange}
                                    isClearable
                                  />
                                </div>
                              </th>
                              {/* <th>
                                <div className="d-flex">
                                  <div className="pr-2">Paid At</div>
                                  <DatePicker
                                    startDate={paidAtDateRange[0]}
                                    endDate={paidAtDateRange[1]}
                                    selectsRange
                                    customInput={
                                      <i className="bx bx-filter-alt font-size-15 cursor-pointer"></i>
                                    }
                                    onChange={setPaidAtDateRange}
                                    isClearable
                                  />
                                </div>
                              </th> */}
                              <Header
                                name="Status"
                                className=""
                                type="transactionStatus"
                              />
                            </tr>
                          </thead>
                          <tbody className="table-body">
                            {transactionData &&
                              transactionData.transactions.edges.map(
                                (transaction, index) => {
                                  return (
                                    <TransactionItem
                                      key={index}
                                      transaction={transaction}
                                      refetch={refetch}
                                      showReject={showReject}
                                      // hasPaidAt
                                      onDone={() => {
                                        refetch();
                                        refetchDeposit();
                                        refetchView();
                                      }}
                                      onDelete={() => {
                                        setConfirmDelete(true);
                                        setTransaction(transaction);
                                      }}
                                      onManageInWorkbench={() => {
                                        history.push({
                                          pathname: "/cashier-workbench",
                                          target: "_blank",
                                          state: {
                                            user: {
                                              node: transaction.node.player,
                                            },
                                          },
                                        });
                                      }}
                                    />
                                  );
                                }
                              )}
                          </tbody>
                        </Table>
                      </InfiniteScroll>
                    )}
                  </div>
                </Col>
              </Row>
              <div className="load-more-container">
                {loading && (
                  <Col xs="12">
                    <div className="text-center my-3">
                      <Link to="#" className="text-success">
                        <i className="bx bx-hourglass bx-spin mr-2"></i> Load
                        more{" "}
                      </Link>
                    </div>
                  </Col>
                )}
              </div>
            </CardBody>
          </Card>
        </Container>
      </div>
      {confirmDelete && (
        <SweetAlert
          error
          showCancel
          confirmBtnBsStyle="danger"
          cancelBtnBsStyle="primary"
          title={"Alert"}
          onConfirm={DeleteTransaction}
          onCancel={() => setConfirmDelete(false)}
        >
          {`Confirm Delete Transaction ${transaction.node.serialNo}`}
        </SweetAlert>
      )}
    </React.Fragment>
  );
  // }
}

const mapStatetoProps = (state) => {
  const { layoutType } = state.Layout;
  return { layoutType, ...state.Transactions };
};

export default connect(mapStatetoProps, { toggleRightSidebar })(
  withTranslation()(TransactionDepositGateway)
);

// export default ContactsList;
